import { createSelector } from '@ngrx/store'
import { AppState } from '../app.state'
import { FeatureMYDState } from './feature-myd.state'

export const getFeatureMYD = (state: AppState) => state.featureManageYourDrafts

export const selectMYDSearchDone = createSelector(getFeatureMYD, (state: FeatureMYDState) => state.isSearchDone)

export const selectMYDIsLoadingSearch = createSelector(getFeatureMYD, (state: FeatureMYDState) => state.isLoading)

export const selectMYDSearchResult = createSelector(getFeatureMYD, (state: FeatureMYDState) => state.searchResult)

export const selectMYDSearchRequest = createSelector(getFeatureMYD, (state: FeatureMYDState) => state.searchRequest)

export const selectMYDDraftCount = createSelector(getFeatureMYD, (state: FeatureMYDState) => state.draftCount)

export const selectMYDIsLoadingDraftCount = createSelector(getFeatureMYD, (state: FeatureMYDState) => state.isLoadingDraftCount)
